import AppStoreIcon from '../../Assets/GymPass/appstore.png';
import GooglePlayIcon from '../../Assets/GymPass/googleplay.png';
import styled from 'styled-components';
import React, { memo } from 'react';

const DownloadButton = () => {
  return (
    <DownloadButtonContainer>
      <ImageLink href="https://apps.apple.com/in/app/nixy/id6448788604" target="_blank">
        <img src={AppStoreIcon} alt="app store" />
      </ImageLink>
      <ImageLink href="https://play.google.com/store/apps/details?id=com.wellness.nixy" target="_blank">
        <img src={GooglePlayIcon} alt="google play store" />
      </ImageLink>
    </DownloadButtonContainer>
  );
};

const ImageLink = styled.a`
  position: relative;
  z-index: 9999;
  cursor: pointer;
`;

const DownloadButtonContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export default memo(DownloadButton);
